import { computed, defineComponent, onMounted, onUpdated, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { AccountAction, AccountGetter } from '@/store/account/account.module';
import { Account } from '@/store/account/account.model';
import { Role } from '@/store/role/role.model';
import { AssignmentAction, AssignmentGetter } from '@/store/assignment/assignment.module';
import { Assignment } from '@/store/assignment/assignment.model';
import { ProjectSearch } from '@/store/project/project.model';
import ProjectFilterComponent from '@/components/project/search/projectFilter/ProjectFilter.vue';
import ProjectTableComponent from '@/components/project/search/projectTable/ProjectTable.vue';
import LoadingComponent from '@/components/loading/Loading.vue';

export default defineComponent({
  name: 'SearchProjectPage',
  components: {
    ProjectFilterComponent,
    ProjectTableComponent,
    LoadingComponent,
  },
  setup: () => {
    const route = useRoute();
    const keyword = computed(() => route.query.keyword);
    const store = useStore();
    const account = computed<Account>(() => store.getters[AccountGetter.ACCOUNT]);
    const userId = computed(() => account.value?.id);
    const mode = computed(() => getMode(store.getters[AccountGetter.SINGLE_ROLE] as Role | undefined));
    const assignment = computed<Assignment | undefined>(() => store.getters[AssignmentGetter.BY_ID](userId.value));
    const isOrs = computed<boolean>(() => store.getters[AccountGetter.IS_ROLE]('เจ้าหน้าที่ ส.กกภ.'));
    const assigned = computed(() => isOrs.value || !!assignment.value);
    const isLoading = computed(() => !isOrs.value && (store.getters[AssignmentGetter.STATUS] === 'init' || store.getters[AssignmentGetter.STATUS] === 'loading'));
    const filterComponent = ref<InstanceType<typeof ProjectFilterComponent>>();
    const tableComponent = ref<InstanceType<typeof ProjectTableComponent>>();
    const filter = ref<ProjectSearch>({});

    onMounted(() => {
      store.dispatch(AccountAction.GET)
        .then(() => {
          if (mode.value !== 'USER') {
            store.dispatch(AssignmentAction.FIND, { mode: mode.value, id: userId.value });
          }
        });
    });

    onUpdated(() => {
      if (keyword.value) {
        setTimeout(() => filterComponent.value?.submit(), 200);
      }
    });

    const searchSubmit = (formData: ProjectSearch) => {
      Promise.resolve(filter.value = formData)
        .then(() => tableComponent.value?.search());
    };

    const getMode = (role: Role | undefined) => {
      switch (role?.name) {
        case 'ผู้แทน ร.นรม./รมต.นร':
          return 'MINISTER';
        case 'ผู้ช่วยผู้ตรวจราชการ':
          return 'REGION';
        case 'เจ้าหน้าที่ประจำจังหวัด':
          return 'PROVINCE';
        default:
          return 'USER';
      }
    };

    return {
      keyword,
      filterComponent,
      tableComponent,
      filter,
      mode,
      userId,
      assigned,
      isLoading,
      searchSubmit,
    };
  },
});
